<template>
  <!--
    Checklist da política de senha (ver src/utils/politicaDeSenha.js).
    Cada item fica verde quando a senha digitada o cumpre — o usuário vê o que
    falta ANTES de enviar, em vez de descobrir pelo erro do servidor.
  -->
  <div class="pr" role="list" aria-label="Requisitos da senha">
    <div
      v-for="r in requisitos"
      :key="r.id"
      class="pr__item"
      :class="{ 'pr__item--ok': r.ok }"
      role="listitem"
    >
      <v-icon small class="pr__icone">
        {{ r.ok ? "mdi-check-circle" : "mdi-circle-outline" }}
      </v-icon>
      <span>{{ r.texto }}</span>
      <span class="sr-only">{{ r.ok ? "(atendido)" : "(pendente)" }}</span>
    </div>
    <div class="pr__item pr__item--info" role="listitem">
      <v-icon small class="pr__icone">mdi-shield-search</v-icon>
      <span>Não pode ser uma senha que já vazou na internet (verificado ao salvar)</span>
    </div>
  </div>
</template>

<script>
import { avaliarSenha } from "@/utils/politicaDeSenha";

export default {
  name: "PasswordRequirements",

  props: {
    senha: { type: String, default: "" },
  },

  computed: {
    requisitos() {
      return avaliarSenha(this.senha);
    },
  },
};
</script>

<style scoped>
.pr {
  display: grid;
  gap: 4px;
  margin: -4px 0 14px;
  padding: 10px 12px;
  border-radius: 8px;
  background: var(--ds-surface-soft, #f7f9fc);
  border: 1px solid var(--ds-border-soft, #eef2f7);
}
.pr__item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  color: var(--ds-text-soft, #78909c);
  transition: color 0.15s ease;
}
.pr__icone {
  color: inherit !important;
}
.pr__item--ok {
  color: var(--ds-success, #2e7d32);
  font-weight: 600;
}
.pr__item--info {
  color: var(--ds-text-muted, #90a4ae);
  font-style: italic;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}
</style>
